import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Card from 'src/components/common/Card.redesign';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import Leasehold from 'src/models/leasehold/Leasehold';
import MineralOwner from 'src/models/MineralOwner';
import AddressUtil from 'src/util/Address';

interface ILeaseholdExtensionCard {
    leasehold: Leasehold;
    index: number;
    submitListener: boolean;
    submitExtensionForm: (leaseholdId: number) => void;
}

const LeaseholdExtensionCard = (props: ILeaseholdExtensionCard) => {
    const { reset, register, errors, getValues } = useForm();
    const [mineralOwner, setMineralOwner] = useState<MineralOwner>(undefined);

    useEffect(() => {
        reset(props.leasehold);
        if (props.leasehold?.mineralOwner) {
            setMineralOwner(props.leasehold?.mineralOwner as unknown as MineralOwner);
        }
    }, [props.leasehold]);

    useEffect(() => {
        if (props.submitListener === true) {
            submitForm();
        }
    }, [props.submitListener]);

    const submitForm = () => {
        let ref = getValues();
        let id = props.leasehold ? props.leasehold.id : 0;

        if (ref.optionExercised && props.leasehold.optionExercised !== true) {
            props.submitExtensionForm(id);
        }
    };

    return (
        <Card>
            <div className="mb-1 mt-1" key={`Staff${props.index}`}>
                <div className="mr-2" style={{ display: 'flex' }}>
                    <div style={{ padding: '1rem', width: '25%' }}>
                        <div>Name: {`${mineralOwner?.name}`}</div>
                        <div>{mineralOwner?.address?.addressLine1}</div>
                        <div>
                            <span>
                                {AddressUtil.concatWithCommas(
                                    mineralOwner?.address?.city,
                                    mineralOwner?.address?.state?.name,
                                    mineralOwner?.address?.zipCode
                                )}
                            </span>
                        </div>
                    </div>
                    <div style={{ padding: '1rem', width: '25%' }}>
                        <span>Expiration Date:</span>
                        <div>
                            {!!props.leasehold?.expirationDate
                            ? moment(props.leasehold?.expirationDate).format('YYYY-MM-DD') as unknown as Date 
                            : 'N/A'}
                        </div>
                    </div>
                    <div style={{ padding: '1rem', width: '25%' }}>
                        <span>Horizon Number:</span>
                        <div>
                            {!!props.leasehold?.horizonNumber
                            ? props.leasehold.horizonNumber
                            : 'N/A'}
                        </div>
                    </div>
                    <div style={{ padding: '1rem', width: '25%' }}>
                        <div style={{ padding: '1rem' }} hidden={props.leasehold?.optionExercised === true}>
                            <RHFCheckbox
                                name="optionExercised"
                                label="Exercise Option?"
                                register={register}
                                errors={errors}
                                disabled={props.leasehold?.optionExercised === true}
                            />
                        </div>
                        <div style={{ padding: '1rem' }} hidden={!props.leasehold?.optionExercised}>
                            <span>Option Exercised</span>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default LeaseholdExtensionCard;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/LeaseholdExtensionCard.tsx